module.exports = __webpack_public_path__ + "i18n/de.ee34f68ca97ae1916cc8bb133af0e8d1.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 997
// module chunks = 60